import React from 'react'
import { PayWithButton } from '../../../../component/InlinePaymentMethod/PayWithButton'
import { SectionHeader } from '../../../../component'
import { useTranslation } from '../../../../utils/convergence'

export const PaymentMethod = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <>
      <SectionHeader title={t('summary:payment')} />
      <PayWithButton />
    </>
  )
}
